var isNumber = require('./isNumber');

    /**
     * Check if value is an integer
     */
    function isInteger(val){
        return isNumber(val) && (val % 1 === 0);
    }

    module.exports = isInteger;





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isInteger.js
// module id = 1608
// module chunks = 0 1 2